import React from 'react';

const FullPageSection = ({ id, children, className = '' }) => {
    return (
        <section id={id} className={className}>
            {children}
        </section>
    );
};

export default FullPageSection;
